import divideBy from './divideBy';

export default divideBy;
